import React from 'react';
import { useSanityFAQ } from '../hooks/use-sanity-faq';

import { BackgroundTexture } from './background-texture';
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
} from '@reach/accordion';
import BlockContent from '@sanity/block-content-to-react';

function FAQs(): React.ReactElement {
  const faqs = useSanityFAQ();
  const [indices, setIndices] = React.useState([0]);

  function toggleItem(toggledIndex) {
    if (indices.includes(toggledIndex)) {
      setIndices(
        indices.filter((currentIndex) => currentIndex !== toggledIndex)
      );
    } else {
      setIndices([...indices, toggledIndex].sort());
    }
  }

  return (
    <div className="relative w-full px-4 py-20 pt-20 mx-auto max-w-screen-2xl sm:px-6 lg:px-8">
      <BackgroundTexture />
      <h1 className="mb-12 text-3xl font-semibold text-center md:mb-14 text-custom-gradient">
        Our Frequently Asked Questions
      </h1>

      <Accordion
        className="relative z-20"
        index={indices}
        onChange={toggleItem}
      >
        {faqs.map((faq, index) => (
          <AccordionItem key={faq.id}>
            <AccordionButton className="flex items-center justify-between w-full px-4 py-4 text-xl font-semibold text-left md:text-2xl sm:px-6 lg:px-8">
              <span className="text-custom-gradient">
                {indices.includes(index) ? '-' : '+'} {faq.question}
              </span>
            </AccordionButton>
            <AccordionPanel className="px-4 py-2 sm:px-6 lg:px-8">
              <BlockContent className="prose" blocks={faq.answer} />
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>

      {/* <BackgroundTexture position="left" /> */}
    </div>
  );
}

export { FAQs };
